<template>
  <v-select
    label="Tipo de IIBB"
    v-model="iModel"
    :items="items"
    item-value="Id_TipoIb"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
export default {
  name: "SelectTipoIb",
  props: {
    model: String,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        var ind = this.items.findIndex(x => x.Id_TipoIb == valor);
        this.$emit("seleccionarItem", this.items[ind]);
      }
    }
  },
  created() {
    this.listarItems();
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get("TipoIb", {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    }
  }
};
</script>
